import { useFormik } from 'formik'
import Container from 'react-bootstrap/Container'
import Modal from 'react-bootstrap/Modal'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import Icon from '../../Icon/Icon'
import Checkbox from '../../Inputs/Checkbox/Checkbox'
import InputDate from '../../Inputs/InputDate/InputDate'
import InputText from '../../Inputs/InputText/InputText'
import Radio from '../../Inputs/Radio/Radio'
import RadioGroup from '../../Inputs/RadioGroup/RadioGroup'
import Typography from '../../Typography/Typography'
import FormInputsContainer from '../FormInputsContainer/FormInputsContainer'
import FormLayout from '../FormLayout/FormLayout'

import { documentSlugs } from 'components/Modal/DocumentPopupWindow/slugs'
import hocFormRegister from '../FormRegister/hocFormRegister'
import './FormRegisterClub.scss'

const FormRegisterClub = ({ handleSubmit, loading, show, onHide, setSlug, ...props }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            gender: '',
            date: '',
            residance: '',
            postalCode: '',
            checkBox: false,
            checkBoxRead: false,
        },
        validationSchema: Yup.object({
            gender: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            date: Yup.date().required(intl.formatMessage({ id: 'forms.required' })),
            residance: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            postalCode: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            checkBox: Yup.boolean().oneOf(
                [true, false],
                intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })
            ),
            checkBoxRead: Yup.boolean().oneOf([true], intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })),
        }),
        onSubmit: (values) => {
            handleSubmit(values)
            formik.handleReset()
            onHide()
            return null
        },
    })

    return (
        <Modal centered show={show} onHide={onHide} className={'form-register-club'} {...props}>
            <FormLayout
                onSubmit={formik.handleSubmit}
                className={`form-register-club--form d-flex flex-column`}
                size="lg"
                color="purple"
            >
                <Icon name={'cross'} className={'position-absolute end-0 top-0 m-3'} role={'button'} onClick={onHide} />
                <RadioGroup
                    id={'gender'}
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.gender' })}
                    error={formik?.errors?.gender}
                    touched={formik?.touched?.gender}
                    {...formik.getFieldProps('gender')}
                >
                    <Radio
                        label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.man' })}
                        value="Male"
                        name={'gender'}
                        error={formik?.errors?.gender}
                        touched={formik?.touched?.gender}
                        disabled={loading}
                        color={'purple'}
                    />
                    <Radio
                        label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.woman' })}
                        value="Female"
                        name={'gender'}
                        error={formik?.errors?.gender}
                        touched={formik?.touched?.gender}
                        disabled={loading}
                        color={'purple'}
                    />
                    <Radio
                        label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.other' })}
                        value="NonBinary"
                        name={'gender'}
                        error={formik?.errors?.gender}
                        touched={formik?.touched?.gender}
                        disabled={loading}
                        color={'purple'}
                    />
                </RadioGroup>

                <FormInputsContainer>
                    <InputDate
                        color={'purple'}
                        name={'date'}
                        id={'date'}
                        error={formik?.errors?.date}
                        touched={formik?.touched?.date}
                        value={formik?.values?.date}
                        onHandle={(date) => {
                            formik.setFieldValue('date', date)
                        }}
                        label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.dateLabel' })}
                        placeholder={intl.formatMessage({
                            id: 'forms.register.cinestarClubMember.datePlaceholder',
                        })}
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                    />
                    <div className="d-none d-md-block w-100" />
                </FormInputsContainer>

                <FormInputsContainer>
                    <InputText
                        color={'purple'}
                        name={'residance'}
                        id={'residance'}
                        error={formik?.errors?.residance}
                        touched={formik?.touched?.residance}
                        {...formik.getFieldProps('residance')}
                        label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.residenceLabel' })}
                        placeholder={intl.formatMessage({
                            id: 'forms.register.cinestarClubMember.residencePlaceholder',
                        })}
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                    />
                    <InputText
                        color={'purple'}
                        type={'number'}
                        name={'postalCode'}
                        id={'postalCode'}
                        error={formik?.errors?.postalCode}
                        touched={formik?.touched?.postalCode}
                        {...formik.getFieldProps('postalCode')}
                        label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.postalCodeLabel' })}
                        placeholder={intl.formatMessage({
                            id: 'forms.register.cinestarClubMember.postalCodePlaceholder',
                        })}
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                    />
                </FormInputsContainer>

                <Container fluid>
                    <Typography variant={'h3'} className={'mb-2'}>
                        {intl.formatMessage({ id: 'forms.register.cinestarClubMember.agreement.title' })}
                    </Typography>
                </Container>

                <Checkbox
                    color={'purple'}
                    name={'checkBox'}
                    id={'checkBox'}
                    error={formik?.errors?.checkBox}
                    touched={formik?.touched?.checkBox}
                    {...formik.getFieldProps('checkBox')}
                    label={intl.formatMessage(
                        { id: 'forms.register.cinestarClubMember.agreement.checkboxLabel' },
                        {
                            link: (chunks) => (
                                <a
                                    onClick={() => setSlug({ slug: documentSlugs.addsNews })}
                                    className="text-decoration-underline"
                                >
                                    {chunks}
                                </a>
                            ),
                        }
                    )}
                    onBlur={formik?.handleBlur}
                    disabled={loading}
                />

                <Checkbox
                    color={'purple'}
                    name={'checkBoxRead'}
                    id={'checkBoxRead'}
                    error={formik?.errors?.checkBoxRead}
                    touched={formik?.touched?.checkBoxRead}
                    {...formik.getFieldProps('checkBoxRead')}
                    label={intl.formatMessage(
                        { id: 'forms.register.cinestarClubMember.agreement.description' },
                        {
                            memberLink: (chunks) => (
                                <a
                                    onClick={() => setSlug({ slug: documentSlugs.loyaltyProgram })}
                                    className="text-decoration-underline"
                                >
                                    {chunks}
                                </a>
                            ),
                            conditions: (chunks) => (
                                <a
                                    onClick={() => setSlug({ slug: documentSlugs.conditions })}
                                    className="text-decoration-underline"
                                >
                                    {chunks}
                                </a>
                            ),
                            personalData: (chunks) => (
                                <a
                                    onClick={() => setSlug({ slug: documentSlugs.personalData })}
                                    className="text-decoration-underline"
                                >
                                    {chunks}
                                </a>
                            ),
                        }
                    )}
                    onBlur={formik?.handleBlur}
                />

                <Typography variant={'tableText'}>
                    {intl.formatMessage({ id: 'forms.register.cinestarClubMember.agreement.description2' })}
                </Typography>

                <FormInputsContainer>
                    <ButtonCinestar variant={'primary-v1'} type={'submit'} disabled={loading}>
                        {intl.formatMessage({ id: 'forms.register.cinestarClubMember.buttonBecomeMember' })}
                    </ButtonCinestar>
                </FormInputsContainer>
            </FormLayout>
        </Modal>
    )
}

export default hocFormRegister(FormRegisterClub)
